import { render, staticRenderFns } from "./ProductTypeGroupEditForm.vue?vue&type=template&id=6fc6aeac&scoped=true"
import script from "./ProductTypeGroupEditForm.vue?vue&type=script&lang=js"
export * from "./ProductTypeGroupEditForm.vue?vue&type=script&lang=js"
import style0 from "./ProductTypeGroupEditForm.vue?vue&type=style&index=0&id=6fc6aeac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc6aeac",
  null
  
)

export default component.exports